<template>
    <div class="ranking">
        <div class="header">
            <p class="fs_50 c_ff lh_70">排行榜</p>
            <div class="mt_10">
                <span class="fs_26 c_ff lh_36">我当前的积分&ensp;{{total_integral}}&emsp;&emsp;</span>
                <span class="fs_26 c_ff lh_36">我的当前排名&ensp;{{rank}}</span>
            </div>
            <div class="flex__between__end mt_20">
                <div class="flex__center__null">
                    <div class="rank-one">
                        <img :src="rank_list[1].headimgurl" alt="">
                        <div class="marker-one">
                            <span class="fs_28 c_98 fw_600">2</span>
                        </div>
                    </div>
                    <span class="fs_28 c_ff lh_50">{{rank_list[1].nickname}}</span>
                    <span class="fs_28 c_ff lh_30">{{rank_list[1].total_integral}}</span>
                </div>
                <div class="flex__center__null">
                    <div class="rank-two">
                        <img :src="rank_list[0].headimgurl" alt="">
                        <div class="marker-two">
                            <span class="fs_36 c_main">1</span>
                        </div>
                    </div>
                    <span class="fs_28 c_ff lh_50">{{rank_list[0].nickname}}</span>
                    <span class="fs_28 c_ff lh_30">{{rank_list[0].total_integral}}</span>
                </div>
                <div class="flex__center__null">
                    <div class="rank-three">
                        <img :src="rank_list[2].headimgurl" alt="">
                        <div class="marker-three">
                            <span class="fs_28">3</span>
                        </div>
                    </div>
                    <span class="fs_28 c_ff lh_50">{{rank_list[2].nickname}}</span>
                    <span class="fs_28 c_ff lh_30">{{rank_list[2].total_integral}}</span>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="flex align-center item" v-for="(item,index) in list" :key="index">
                <span class="fs_32 c_98 fw_600">{{index+4}}&emsp;</span>
                <img :src="item.headimgurl" alt="">
                <div class="flex__null__between ml_20">
                    <span class="fs_28 c_1a lh_40">{{item.nickname}}</span>
                    <span class="fs_24 c_98 lh_30">累计积分{{item.total_integral}}</span>
                </div>
            </div>
        </div> 
    </div>
</template>
<script>
export default {
    name: "Ranking",
    data(){
        return{
            total_integral:0,
            rank: 0,
            rank_list: [],
            list: []
        }
    },
    mounted(){
        this.axios.post('/wechat.php/Integral/getRankData',{
            user_id: localStorage.user_id
        }).then(
            res=>{
                if(res.data.code==1){
                    this.total_integral=res.data.data.total_integral;
                    this.rank=res.data.data.rank;
                    this.rank_list=res.data.data.rank_list.concat();
                    this.list=res.data.data.rank_list.splice(3,res.data.data.rank_list.length-1);
                }
            }
        )
    }
}
</script>
<style scoped>
.ranking{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background:linear-gradient(180deg,#FF955E 0%,#F22626 100%);
}
.header{
    padding: 30px 40px;
}
.rank-one,.rank-two,.rank-three{
    position: relative;
    width: 106px;
}
.rank-two{
    width: 136px;
}
.rank-one img,.rank-three img{
    width: 106px;
    height: 106px;
    border: 6px solid #FDA281;
    border-radius: 50%;
}
.rank-two img{
    width: 136px;
    height: 136px;
    border: 6px solid #FDA281;
    border-radius: 50%;
}
.marker-one,.marker-two,.marker-three{
    position: absolute;
    bottom: 0;
    right: 0;
    border: 2px solid #989898;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    line-height: 36px;
    text-align: center;
    background: #cbcbcb;
}
.marker-two{
    width: 50px;
    height: 50px;
    background: #FFD437;
    border: 2px solid #E36200;
    line-height: 46px;
}
.marker-three{
    background: #D5B1B1;
    border: 2px solid #B67650;
}
.marker-three span{
    font-weight: 600;
    color: #B67650;
}
.content{
    position: fixed;
    top: 400px;
    bottom: 20px;
    width: 100%;
    padding: 0 20px;
    overflow: auto;
}
.item{
    height: 130px;
    padding: 0 26px;
    margin-top: 15px;
    background: #fff;
}
.item img{
    width: 70px;
    height: 70px;
    border-radius: 50%;
}
</style>





// WEBPACK FOOTER //
// src/pages/integral/Ranking.vue